import { Component, Input, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { NoWhiteSpaceValidator } from '../../../../../core/shared/validators/whitespace-validator';
import {
  AddUpdateChannel,
  DeleteChannel,
} from '../../../../../core/shared/actions/channel.actions';
import { Channel } from '../../../../../core/shared/models/channel.model';
import { ConfirmationModalComponent } from '../../../../../core/shared/components/modals/confirmation-modal/confirmation-modal.component';
@Component({
  selector: 'app-channel-modal',
  templateUrl: './channel-modal.component.html',
  styleUrls: ['./channel-modal.component.scss'],
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, MatSnackBarModule, MatFormField, MatLabel, MatInput, MatError, MatIcon, MatButton, MatIconButton],
})
export class ChannelModalComponent implements OnInit {
  @Input() public applicationName!: string;
  @Input() public channel?: Channel;
  @Input() public formMode = 'New';
  @Input() public editChannel = false;
  private formSubscription: Subscription = new Subscription();
  entryForm!: FormGroup;
  error: string | undefined;

  constructor(
    public modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public store: Store
  ) {
    this.createForm();
  }

  ngOnInit() {
    this.createForm();
    if (this.channel) {
      this.entryForm.patchValue({
        application: this.channel.application,
        channel_name: this.channel.channel_name,
        Description: this.channel.Description,
      });
      this.editChannel = true;
    } else {
      this.editChannel = false;
    }
  }

  //   // Handle Create  update button click
  onCreate_Update(): void {
    this.entryForm.controls['channel_name'].setValue(
      this.entryForm.controls['channel_name'].value.trim()
    );
    this.entryForm.controls['application'].setValue(this.applicationName);
    this.entryForm.controls['channel_name'].setValue(
      this.entryForm.controls['channel_name'].value
    );
    this.formSubscription.add(
      this.store
        .dispatch(
          new AddUpdateChannel(
            this.applicationName,
            this.entryForm.controls['channel_name'].value,
            this.entryForm.value
          )
        )
        .subscribe(
          (resp: any) => {
            this.activeModal.close();
            this.showSnackBar('Channel list updated successfully!', false);
          },
          (error) => {
            this.activeModal.close();
            this.showSnackBar('An error occurred:' + error.error.message, true);
          }
        )
    );
  }

  openConfirmModal(message: string) {
    // Open modal form component
    const modalRef = this.modalService.open(ConfirmationModalComponent, {});
    modalRef.componentInstance.message = message;
    modalRef.result.then((event) => {
      if (event == 'confirm') {
        this.onDelete();
      }
    });
  }

  // Handle Delete button click
  onDelete() {
    this.store
      .dispatch(
        new DeleteChannel(
          this.applicationName,
          this.entryForm.controls['channel_name'].value
        )
      )
      .subscribe(
        (resp: any) => {
          this.activeModal.close();
          this.showSnackBar(
            'The Channel has been successfully deleted!!',
            false
          );
        },
        (error) => {
          this.activeModal.close();
          this.showSnackBar('An error occurred:' + error.error.message, true);
        }
      );
  }

  // reactive form
  private createForm() {
    this.entryForm = this.formBuilder.group({
      application: [''],
      channel_name: new FormControl('', [
        Validators.required,
        NoWhiteSpaceValidator.cannotContainSpace,
      ]),
      Description: new FormControl(''),
    });
  }

  showSnackBar(message: string, isError: boolean): void {
    this.snackBar.open(message, 'Close', {
      duration: 3000, // Duration in milliseconds
      panelClass: isError ? 'error-snackbar' : 'success-snackbar', // Custom CSS classes for styling
    });
  }

  clearForm() {
    this.entryForm.reset();
  }
}
